export default {
  pageName: 'AI Topic Analysis List',
  pageId: '26022',
  pagePath: '/opinion/AIAnalysisHub/AITopicAnalysis?tab=savedAnalysisList',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    PreviewAnalysis: {
      buttonId: '2602201',
    },
    SearchAnalysis: {
      buttonId: '2602202',
    },
    DownloadReport: {
      buttonId: '2602203',
    },
    Delete: {
      buttonId: '2602204',
    },
    Stop: {
      buttonId: '2602205',
    },
  },
};
